import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Modal from "react-modal";
import "./UserModal.css";
import { MdOutlineEmail } from "react-icons/md";
import { LuUserRound, LuLock, LuEye } from "react-icons/lu";
import { HiOutlinePhone } from "react-icons/hi";
import { IoClose } from "react-icons/io5";
import UserImg from "../../assets/userimg.avif";
import api from "../../api";
import Swal from "sweetalert2";
import { color } from "framer-motion";
Modal.setAppElement("#root");

const UserModal = ({ isOpen, onClose }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    phonenumber: "",
    confirmPassword: "",
    rememberMe: false,
    acceptTerms: false,
    nameChecked: false,
    emailChecked: false,
    passwordChecked: false,
    confirmPasswordChecked: false,
  });
  const [selectedCountry, setSelectedCountry] = useState("+1");

  const [countries, setCountries] = useState([]);

  useEffect(() => {}, [isLogin]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // const handleCheckboxChange = (checkboxName) => {
  //   setFormData({
  //     ...formData,
  //     [checkboxName]: !formData[checkboxName]
  //   });
  // };
 useEffect(() => {
    const fetchCountries = async () => {
      const res = await api.get("countries/show-countries");
      setCountries(res.data);
    };
    fetchCountries();
  }, []);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };
  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await api.post(
        "auth/login",
        {
          email: formData.email,
          password: formData.password,
        },
        { withCredentials: true }, // ✅ send HTTP-only cookie
      );

      setIsLogin(true);
      onClose();

      await Swal.fire({
        title: "Login Successful",
        text: res.data.message || "Welcome back!",
        icon: "success",
        confirmButtonText: "Continue",
        confirmButtonColor: "#993400",
      });

      setFormData({ email: "", password: "" });
    } catch (err) {
      if (err.response) {
        Swal.fire({
          title: "Login Failed",
          text: err.response.data.message,
          icon: "error",
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Login failed. Try again later.",
          icon: "error",
        });
      }
      console.error(err);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    // Check password confirmation
    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    // Prepare FormData for API
    const data = new FormData();
    const fullPhone = selectedCountry + formData.phonenumber;

    data.append("Action", "register");
    data.append("name", formData.name);
    data.append("email", formData.email);
    data.append("phonenumber", fullPhone);
    data.append("password", formData.password);

    try {
      const res = await api.post("user", data);
      alert(res.data.message);

      // Reset form and switch to login
      setIsLogin(true);
      setFormData({
        name: "",
        email: "",
        password: "",
        phonenumber: "",
        confirmPassword: "",
        rememberMe: false,
        acceptTerms: false,
      });
    } catch (err) {
      if (err.response) {
        alert(err.response.data.message);
      } else {
        alert("Registration failed. Try again later.");
      }
      console.error(err);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="auth-overlay"
      className="auth-box"
    >
      <div className="auth-header">
        <h2 className="auth-title">{isLogin ? "Login" : "Registration"}</h2>
        <button
          className="auth-close-btn"
          onClick={onClose}
          type="button"
          aria-label="Close modal"
        >
          <IoClose size={24} />
        </button>
      </div>
      <div className="user-img">
        <img src={UserImg} alt="" />
      </div>
      <form className="auth-form">
        {!isLogin && (
          <div className="input-row">
            {/* <div 
              className={`checkbox-icon ${formData.nameChecked ? 'checked' : ''}`}
              onClick={() => handleCheckboxChange('nameChecked')}
            >
              {formData.nameChecked && <FaCheck />}
            </div> */}
            <div className="input-group-user">
              <LuUserRound />
              <input
                type="text"
                placeholder="Enter your name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
              />
            </div>
          </div>
        )}

        <div className="input-row">
          {/* {!isLogin && (
            <div 
              className={`checkbox-icon ${formData.emailChecked ? 'checked' : ''}`}
              onClick={() => handleCheckboxChange('emailChecked')}
            >
              {formData.emailChecked && <FaCheck />}
            </div>
          )} */}
          <div className="input-group-user">
            <MdOutlineEmail />
            <input
              type="email"
              placeholder="Enter your email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
            />
          </div>
        </div>
        {!isLogin && (
          <div className="input-row">
            <div className="input-group-user">
              <HiOutlinePhone />
              <select
                value={selectedCountry}
                onChange={(e) => setSelectedCountry(e.target.value)}
                style={{ width: "90px", marginRight: "10px" }}
              >
                {countries.map((country, idx) => (
                  <option key={idx} value={country.code}>
                    {country.name} ({country.phone_code}) 
                  </option>
                ))}
              </select>
              <input
                type="tel"
                placeholder="Enter your phone number"
                name="phonenumber"
                value={formData.phonenumber}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>
        )}

        <div className="input-row">
          {/* {!isLogin && (
            <div 
              className={`checkbox-icon ${formData.passwordChecked ? 'checked' : ''}`}
              onClick={() => handleCheckboxChange('passwordChecked')}
            >
              {formData.passwordChecked && <FaCheck />}
            </div>
          )} */}
          <div className="input-group-user">
            <LuLock />
            <input
              type={showPassword ? "text" : "password"}
              placeholder={isLogin ? "Create a password" : "Create a password"}
              name="password"
              value={formData.password}
              onChange={handleInputChange}
            />
            <LuEye className="eye" onClick={togglePasswordVisibility} />
          </div>
        </div>

        {!isLogin && (
          <div className="input-row">
            {/* <div 
              className={`checkbox-icon ${formData.confirmPasswordChecked ? 'checked' : ''}`}
              onClick={() => handleCheckboxChange('confirmPasswordChecked')}
            >
              {formData.confirmPasswordChecked && <FaCheck />}
            </div> */}
            <div className="input-group-user">
              <LuLock />
              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm a password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleInputChange}
              />
              <LuEye
                className="eye"
                onClick={toggleConfirmPasswordVisibility}
              />
            </div>
          </div>
        )}

        {isLogin ? (
          <div className="row">
            <label className="checkbox">
              <input
                type="checkbox"
                name="rememberMe"
                checked={formData.rememberMe}
                onChange={handleInputChange}
              />
              Remember me
            </label>
            <span className="link">Forgot password?</span>
          </div>
        ) : (
          <label className="checkbox">
            <input
              type="checkbox"
              name="acceptTerms"
              checked={formData.acceptTerms}
              onChange={handleInputChange}
            />
            I accept all terms & conditions
            <Link style={{color:'#9a3300'}} to="/TermsConditions"  target="_blank"
  rel="noopener noreferrer">Terms & Conditions</Link>
          </label>
        )}

        <button
          className="primary-btn"
          onClick={isLogin ? handleLogin : handleRegister}
        >
          {isLogin ? "Login Now" : "Register Now"}
        </button>
      </form>

      <p className="switch-text">
        {isLogin ? (
          <>
            Don't have an account?
            <span onClick={() => setIsLogin(false)}> Signup now</span>
          </>
        ) : (
          <>
            Already have an account?
            <span onClick={() => setIsLogin(true)}> Login now</span>
          </>
        )}
      </p>
    </Modal>
  );
};

export default UserModal;
